// import ApeModeQueryParamReader from 'hooks/useApeModeQueryParamReader'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components/macro'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'

import Web3ReactManager from '../components/Web3ReactManager'
import ErrorBoundary from '../components/ErrorBoundary'
import Header from 'components/Header'
import Polling from '../components/Header/Polling'
import Popups from '../components/Popups'
import Footer from 'components/Footer'

import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'

import Home from './Home'
import Nfts from './NFTS'
import Process from './Process'

import { RedirectPathToHomeOnly } from './Home/redirects'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 76px 0px 0px 0px;
  align-items: center;
  flex: 1;
  z-index: 1;
  min-height: calc(100vh - 65px);
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 2;
`

function App() {
  return (
    <ErrorBoundary>
      <Route component={GoogleAnalyticsReporter} />
      <Route component={DarkModeQueryParamReader} />
      {/* <Route component={ApeModeQueryParamReader} /> */}
      <Web3ReactManager>
        <AppWrapper>
          <HeaderWrapper>
            <Header />
          </HeaderWrapper>
          <BodyWrapper>
            <Popups />
            <Polling />
            <Switch>
              <Route exact strict path="/app/home" component={Home} />
              <Route exact strict path="/app/nfts" component={Nfts} />
              <Route exact strict path="/app/process" component={Process} />
              <Route component={RedirectPathToHomeOnly} />
            </Switch>
          </BodyWrapper>
          <Footer />
        </AppWrapper>
      </Web3ReactManager>
    </ErrorBoundary>
  )
}

export default App
